export default __webpack_public_path__ + "static/media/Jaipuroverview.d8f1ff76.jpg";